<script setup lang="ts">
import { useField } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';
import { z } from 'zod';
import { SUREbusinessCommonDomainRelatiesTitulatuurcodeType as TitulatuurcodeType } from '@services/crm-public/orval-api/model/sUREbusinessCommonDomainRelatiesTitulatuurcodeType';
import { inject, ref } from 'vue';

import SelectField from '@shared/form/SelectField/SelectField.vue';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import { isDisabledInjectionKey, isReadonlyInjectionKey } from '../keys';
import { getTitulatuurOptions } from '../../types';

const { value: hasDisabledParent } = inject(isDisabledInjectionKey, { value: ref(false) });
const { value: hasReadonlyParent } = inject(isReadonlyInjectionKey, { value: ref(false) });

const titulatuurcode = useField('titulatuurcode', toTypedSchema(z.nativeEnum(TitulatuurcodeType)));
</script>

<template>
  <FieldRowV2
    data-testid="relatiegegevens-aanhef"
    :errors="titulatuurcode.errors.value"
    label="Aanhef"
    :required="!hasReadonlyParent"
    v-bind="$attrs"
  >
    <SelectField
      v-model:value="titulatuurcode.value.value"
      :disabled="hasDisabledParent"
      :readonly="hasReadonlyParent"
      :has-error="!!titulatuurcode.errors.value.length"
      :options="getTitulatuurOptions(titulatuurcode.value.value)"
      placeholder="Aanhef"
      id="relatiegegevens-aanhef"
    />
  </FieldRowV2>
</template>
